import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Residencia = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="PROGRAMAS DE RESIDÊNCIA" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantos Programas de Residência" nome="residenciaprograma" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Existe Fisioterapeuta Fixo na Equipe" nome="resifixo" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="10vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        {RenderQtdResidencia()}
                    </div>

                    <HeaderVerde texto="RESIDENTES" />
                    <div style={{ textAlign: "left" }}>
                    <Input label="Quantos Residentes" nome="residentes" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdResidencia2()}
                    </div>
                </Caixa>
            )

            function RenderQtdResidencia() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["residenciaprograma"]
                if (array[modulo][n]["residenciaprograma"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Programa" nome="resiprograma" modulo={modulo} index={n} subModulo="resiprograma" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="17vw" widthMobile="80vw" marginR="3vw" />
                                <Input label="Coordenador" nome="resicoord" modulo={modulo} index={n} subModulo="resicoord" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                                <Input label="Tutor" nome="resitutor" modulo={modulo} index={n} subModulo="resitutor" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                                <Select label="Tutor é Fisioterapeuta" nome="resitutorfisio" modulo={modulo} index={n} subModulo="resitutorfisio" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="7vw" widthMobile="80vw" marginR="3vw"
                                    array={["Sim", "Não"]} />

                            </div>
                        )
                    }
                }
                return campos
            }
            function RenderQtdResidencia2() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["residentes"]
                if (array[modulo][n]["residentes"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Nome" nome="residnome" modulo={modulo} index={n} subModulo="residnome" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="51vw" widthMobile="80vw" marginR="3vw" />
                                
                                <Input label="Crefito" nome="resicrefito" modulo={modulo} index={n} subModulo="resicrefito" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="11vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="Ano da Residência" nome="resiano" modulo={modulo} index={n} subModulo="resiano" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="11vw" widthMobile="80vw" marginR="3vw" />
                               
                                <Input label="Outras Informações" nome="resinfor" modulo={modulo} index={n} subModulo="resinfor" indexSub={i}
                                    componentDisplay="block" widthWeb="79vw" widthMobile="79vw" marginR="3vw" />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}
export default Residencia